/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
export const IDEAL_PAYLOAD_SIZE = 64000;
export const MAX_PAYLOAD_SIZE = 1000000;
export const DEFAULT_KEY = 'NR_CONTAINER_AGENT';